import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';
import { Container, Share } from '@uncinc/uncinc-react-kitchen-sink';
import type { OptionalArrayField, ReferenceField } from '@uncinc/react-drupal-core/types';

import type { TaxonomyThemes } from '../../types/uncinc_profile/taxonomy';
import ThemesLabels from '../ThemesLabels';

interface ShareWrapperProps {
  withThemes?: boolean;
  themes?: OptionalArrayField<[ReferenceField<TaxonomyThemes>]>;
}


const ShareWrapper: React.FC<ShareWrapperProps> = ({ withThemes = false, themes = [] }) => {
  const { t } = useTranslation();

  const dossiers: ReferenceField<TaxonomyThemes>[] = [];
  const mainThemes: ReferenceField<TaxonomyThemes>[] = [];

  themes.forEach((theme) => {
    const hasEntity = theme.entity;
    const hasParent = theme.entity?.parent[0]?.target_id;

    if (hasEntity) {
      if (!hasParent) {
        // if no parent then it's a theme, push it into mainthemes.
        mainThemes.push(theme);
      } else {
        dossiers.push(theme);
      }
    }
  });

  return (
    <div className="Share">
      <Container>
        <div className="row">
          <div className="col-12">
            <div className="Share__inner">
              <div className="Share__socials">
                <Share
                  isDropdown={false}
                  title={t('share.share_page')}
                  withLabels
                  items={[
                    'facebook',
                    'linkedin',
                    'twitter',
                    'mail',
                  ]}
                />
              </div>
              {withThemes && (
                <div className="Share__themes">
                  {dossiers.length > 0 && (
                    <div className="Share__themes__section">
                      <h4>{t('share.read_more')}</h4>
                      <ThemesLabels themes={dossiers} />
                    </div>
                  )}
                  {mainThemes.length > 0 && (
                    <div className="Share__themes__section">
                      <h4>{t('share.themes')}</h4>
                      <ThemesLabels themes={mainThemes} isMainTheme />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default ShareWrapper;
